// extracted by mini-css-extract-plugin
module.exports = {"loading":"styles_loading__X8wTG","spinner":"styles_spinner__n7GCM","spin":"styles_spin__rXv3I"};
module.exports.__checksum = "703b501b8979"